import React from 'react';
import DashboardsTable from './DashboardsTable';

const DashboardsList: React.FC<{
  onEditDashboardName?: (dashboardId: string) => void;
  searchValue?: string;
  onCreateDashboard?: () => void;
}> = ({ onEditDashboardName, searchValue = '', onCreateDashboard }) => {
  return (
    <div className='pb-4 px-6'>
      <div className='mt-4'>
        <DashboardsTable
          searchValue={searchValue}
          onEditDashboardName={onEditDashboardName}
          createNewDashboard={onCreateDashboard}
        />
      </div>
    </div>
  );
};

export default DashboardsList;
